import MessageForm from "./MessageForm";

export default MessageForm;